import { createSlice } from "@reduxjs/toolkit";
import { fetchAllContributions, fetchUserFines } from "../api/api";

const initialState = {
  loading: false,
  allContributions: null,
  totalFines: 0,
  unpaidFines: [],
  error: {},
};

const getAllContributions = createSlice({
  name: "getAllContributions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // -------------------- FETCH ALL CONTRIBUTIONS --------------------
    builder
      .addCase(fetchAllContributions.pending, (state) => {
        state.loading = true;
        state.allContributions = null;
        state.error = {};
      })
      .addCase(fetchAllContributions.fulfilled, (state, action) => {
        state.loading = false;
        state.allContributions = action.payload;
        state.error = {};
      })
      .addCase(fetchAllContributions.rejected, (state, action) => {
        state.loading = false;
        state.allContributions = null;
        state.error = action.payload;
      });

    // -------------------- FETCH USER FINES --------------------
    builder
      .addCase(fetchUserFines.pending, (state) => {
        state.loading = true;
        state.totalFines = 0;
        state.unpaidFines = [];
        state.error = {};
      })
      .addCase(fetchUserFines.fulfilled, (state, action) => {
        state.loading = false;
        state.totalFines = action.payload.total_fines;
        state.unpaidFines = action.payload.unpaid_fines;
        state.error = {};
      })
      .addCase(fetchUserFines.rejected, (state, action) => {
        state.loading = false;
        state.totalFines = 0;
        state.unpaidFines = [];
        state.error = action.payload;
      });
  },
});

export default getAllContributions.reducer;
